import { propClassName } from '@/styles/AuthorsList';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from 'lib/utils';

export interface AuthorsListItemProps extends ComponentProps<'div'> {
  colors?: ClassNameProp;
  size?: ClassNameProp;
  variant?: ClassNameProp;
}

export const AuthorsListItemComponent: Component<AuthorsListItemProps> = ({
  children,
  className,
  colors,
  size,
  variant,
  ...props
}) => {
  const colorsClassName = propClassName('item_colors', colors);
  const sizeClassName = propClassName('item_size', size);
  const variantClassName = propClassName('item_variant', variant);

  const componentClassName = cn(colorsClassName, sizeClassName, variantClassName, className);

  return (
    <div className={componentClassName} {...props}>
      {children}
    </div>
  );
};
